import request from "@/utils/request";

export function sendMultiLanguage(data) {
  return request({
    url: "api/contactus/multilanguage",
    method: "post",
    data
  });
}